import { useEffect, useState } from 'react';
import { useDevice } from '@/contexts/DeviceContext';
import { useAuth } from '@/contexts/AuthContext';
import './Header.scss';
import Logo from '@/assets/icons/logo.svg?react';
export function Header() {
    const { isMobile } = useDevice();
    const { user, logout } = useAuth();
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const formatDateTime = (date: Date) => {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const dayOfWeek = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours < 12 ? '오전' : '오후';
        const hour12 = hours % 12 || 12;

        return `${month}월 ${day}일 (${dayOfWeek}) ${ampm} ${hour12}:${minutes}`;
    };

    const handleLogout = async () => {
        await logout();
    };

    return (
        <header className={`center-header ${isMobile ? 'center-header--mobile' : ''}`}>
            <Logo className="center-header__logo" />
            <div className="center-header__right">
                {user?.name &&
                    <>
                        <span className="user-name">{user.name} 님</span>
                        <button className="logout-btn" onClick={handleLogout}>
                            로그아웃
                        </button>
                    </>
                }
                <span className="current-time">{formatDateTime(currentTime)}</span>
            </div>
        </header>
    );
}
